import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { RequireAuth } from '@/components/RequireAuth';
import { SignInPage } from '@/features/auth/SignInPage';
import { ConversationsListPage } from '@/features/conversations/ConversationsListPage';
import { ConversationDetailPage } from '@/features/conversations/ConversationDetailPage';
import { NewConversationPage } from '@/features/conversations/NewConversationPage';
import { CustomersPage } from '@/features/customers/CustomersPage';
import { TopicsPage } from '@/features/topics/TopicsPage';
import { DocumentsPage } from '@/features/documents/DocumentsPage';
import { MetricsPage } from '@/features/metrics/MetricsPage';
import { AuditPage } from '@/features/audit/AuditPage';
import { NotFoundPage } from '@/features/NotFoundPage';

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  { path: '/sign-in', element: <SignInPage /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <Layout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/conversations" replace /> },
      { path: 'conversations', element: <ConversationsListPage /> },
      { path: 'conversations/new', element: <NewConversationPage /> },
      { path: 'conversations/:id', element: <ConversationDetailPage /> },
      { path: 'customers', element: <CustomersPage /> },
      {
        path: 'topics',
        element: (
          <RequireAuth role="manager">
            <TopicsPage />
          </RequireAuth>
        ),
      },
      {
        path: 'documents',
        element: (
          <RequireAuth role="manager">
            <DocumentsPage />
          </RequireAuth>
        ),
      },
      {
        path: 'metrics',
        element: (
          <RequireAuth role="manager">
            <MetricsPage />
          </RequireAuth>
        ),
      },
      {
        path: 'audit',
        element: (
          <RequireAuth role="manager">
            <AuditPage />
          </RequireAuth>
        ),
      },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);
